<template>
  <div class="video">
    <video-player ref="videoPlayer"
                  v-if="!isOldAndroid"
                  :options="videoOptions"></video-player>
    <video ref="videofile"
           controls
           v-if="isOldAndroid"
           :src="video.video_url || video.url"
           preload="auto">
    </video>
  </div>
</template>

<script>
import Mobile from '@/mixins/Mobile';

export default {
  name: 'content-video',

  mixins: [
    Mobile,
  ],

  props: [
    'video',
  ],

  computed: {
    videoOptions() {
      return {
        sources: [{
          type: 'video/mp4',
          src: this.video.video_url || this.video.url,
        }],
        poster: this.video.poster_url,
      };
    },

    player() {
      return this.$refs.videoPlayer.player;
    },
  },

  created() {
    window.pauseMedia = () => {
      if (this.isOldAndroid) {
        this.$refs.videofile.pause();
      } else {
        this.player.pause();
      }
    };
  },
};
</script>
